import { Outlet } from 'react-router';

import { useUser } from '@/state';
import Loading from '@/components/loading/component';

export const DashboardLayout = () => {
  const { user, loading, error } = useUser();
  if (!user && !loading) {
    return <div>{error?.message}</div>;
  }
  if (loading) {
    return <Loading />;
  }

  return <Outlet />;
};

export default DashboardLayout;
